const update_status = {
	forced_reset: "Reset erzwingen",
	forced_shutdown: "Abschaltung erzwingen",
	reboot: "Neustart",
	shutdown: "Abschaltung",
	start: "Start",
};

export default update_status;
